import { render, staticRenderFns } from "./ClaimReporting.vue?vue&type=template&id=5b456b00"
import script from "./ClaimReporting.vue?vue&type=script&lang=js"
export * from "./ClaimReporting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports